import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export function useFixLeadMarket() {
  return useMutation({
    mutationFn: async () => {
      const { data, error } = await supabase.functions.invoke('facebook-leads-fix-market', {
        body: {}
      });

      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      toast.success(`Market corrigido com sucesso!`, {
        description: `${data.corrected} leads atualizados de ${data.total_leads} processados`
      });
    },
    onError: (error) => {
      console.error('Error fixing markets:', error);
      toast.error('Erro ao corrigir markets', {
        description: String(error)
      });
    }
  });
}
